import { GetMonthlyInvoiceRawResponse, GetMonthlyInvoiceResponse } from "./types";

export const transformMonthlyInvoice = (res: GetMonthlyInvoiceRawResponse) => {
  const {
    _embedded: { invoices: items },
    page,
    page_count,
    page_size,
    total_items,
    _links,
  } = res;

  const response: GetMonthlyInvoiceResponse = {
    data: {
      items: items.map((i) => ({
        id: i.uuid,
        providerKey: i.provider_key,
        identifier: i.identifier,
        status: i.status,
        amount: i.amount,
        currency: i.currency,
        invoiceMonth: i.invoice_month,
        issueDate: i.issue_date,
        documents: i.documents,
        createdAt: i.created_at,
        updatedAt: i.updated_at,
      })),
      page: {
        current: page,
        count: page_count,
        size: page_size,
        total: total_items,
      },
    },
    links: _links,
  };

  return response;
};
